import { AlertContents } from '@components/AlertRibbon/AlertRibbon.styled';
import { NotificationData, UIConstants, NotificationDefaultValue } from '@constants';
import React, { useState } from 'react';
import { CardContentWrapper, CardWrapper, Content, Wrapper } from './NotificationCard.styled';
import Link from '@components/Link/Link';
import { NotificationCardProps } from '@types';

export const NotificationCard: React.FC<NotificationCardProps> = ({ alertData }) => {
    const { subject, content, link, template } = alertData;

    const priorityData = NotificationData[template?.templateIcon] || NotificationDefaultValue;

    const [showNotification, setShowNotification] = useState(true);

    const handleNotificationClose = () => {
        setShowNotification(false);
    };
    return (
        <>
            {showNotification && (
                <CardWrapper borderColor={priorityData?.borderColor}>
                    <CardContentWrapper>
                        <Wrapper>
                            <img src={priorityData?.imgSrc} width={33} height={33} />
                            <AlertContents id="alertContents" role="alertContents">
                                <Content>
                                    {subject}&nbsp;{content}&nbsp;
                                    {link && (
                                        <Link id="learnMore" href={link} target="_blank" fontSize="14px" fontWeight="normal">
                                            {UIConstants.learnMore}
                                        </Link>
                                    )}
                                </Content>
                            </AlertContents>
                        </Wrapper>
                        <img
                            src="https://dam.freedommortgage.com/dx/api/dam/v1/collections/563a2e94-abdb-4eda-a407-49cc1380b6f4/items/b08f0e6d-bfc2-4e54-88c2-e833c025fdc3/renditions/dfd1efbf-ec0a-49b6-b3ab-bad49d99dbdd?binary=true"
                            alt="CloseButton"
                            width={33}
                            height={33}
                            onClick={handleNotificationClose}
                        />
                    </CardContentWrapper>
                </CardWrapper>
            )}
        </>
    );
};
